import { Loader2 } from "lucide-react";
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OfflineEmptyState } from "@/components/OfflineEmptyState";

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    // Offline while loading — show empty state instead of spinner
    if (!navigator.onLine) {
      return <OfflineEmptyState />;
    }

    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // Offline with no user — show empty state instead of redirect to /auth
    if (!navigator.onLine) {
      return <OfflineEmptyState />;
    }
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};
